export const loginConstants = {
	LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
	USER_LOGOUT: 'USER_LOGOUT',
};
